/// <amd-module name="Repos/Common/Constants" />
export const maxTagSuggestions = 100;
export const themeIndependentStyle = { backgroundColor: "inherit", color: "inherit" };
